import { apiSlice } from "./apiSlice.js";
import { 
    USER_AUTHENTICATION_URL, 
    USER_LOGOUT_URL, 
    USER_REGISTRATION_URL, 
    USER_PROFILE_URL, 
    USER_DELETE_URL,
    USER_ACTIVE_REWARDS_DATA_URL,
    USER_DATA_FETCH_URL,
    USER_POINTS_TRANS_URL,
    USER_STAMP_TRANS_URL,
    USER_REWARD_REDEEMED_HISTORY_URL,
    USER_REWARD_QRCODE_URL,
    USER_DECRYPT_REWARD_QRCODE_URL,
    USER_CHANGE_PASSWORD_URL,
    USER_SEND_EMAIL_OTP_URL,
    USER_VERIFY_EMAIL_URL,
    // USER_PHONE_EXISTS_URL,
    USER_UPDATE_EXPIRED_TRANSACTION_URL,
    USER_UPDATE_STAMP_EXPIRED_TRANSACTION_URL,
    USER_FORGET_PASSWORD_VERIFY_OTP_URL,
    USER_FORGET_PASSWORD_SEND_EMAIL_OTP_URL,
    USER_RESET_PASSWORD_URL,
    USER_STAMP_REWARD_DATA_URL,
    USER_CHECK_EMAIL_EXIST_URL,
    USER_POINTS_EXPIRY_SOON_URL
} from '../utils/constants.js';

const USER_AUTH_URL = USER_AUTHENTICATION_URL; 

export const usersApiSlice = apiSlice.injectEndpoints({
    endpoints: (builder) => ({
        login: builder.mutation({
            query: (data) => ({
                url: USER_AUTH_URL,
                method: 'POST',
                body: data,
                credentials: 'include',
            }),
        }),
        logout: builder.mutation({
            query: () => ({
                url: USER_LOGOUT_URL,
                method: 'POST',
                credentials: 'include',
            }),
        }),
        register: builder.mutation({
            query: (data) => ({
                url: USER_REGISTRATION_URL,
                method: 'POST',
                body: data,
                credentials: 'include',
            }),
        }),
        updateUser: builder.mutation({
            query: (data) => ({
                url: USER_PROFILE_URL,
                method: 'PUT',
                body: data,
                credentials: 'include',
            }),
        }),
        deleteUser: builder.mutation({
            query: (id) => ({
                url: `${USER_DELETE_URL}/${id}`,
                method: 'DELETE',
                credentials: 'include',
            }),
            invalidatesTags: ['User', 'Transaction'], // Refresh data after deletion
        }),
        getActiveRewardsData: builder.mutation({
            query: () => ({
                url: USER_ACTIVE_REWARDS_DATA_URL,
                method: 'GET',
                credentials: 'include',
            }),
        }),
        getUserData: builder.mutation({
            query: (id) => ({
                url: `${USER_DATA_FETCH_URL}/${id}`,
                method: 'GET',
                credentials: 'include',
            }),
        }),
        fetchUserPointTransactions: builder.mutation({
            query: ({ id, selectedMonth, selectedYear }) => ({
                url: `${USER_POINTS_TRANS_URL}/${id}?selectedMonth=${selectedMonth}&selectedYear=${selectedYear}`,
                method: 'GET',
                credentials: 'include',
            }),
        }),
        fetchUserStampTransactions: builder.mutation({
            query: (userId) => ({
                url: `${USER_STAMP_TRANS_URL}/${userId}`,
                method: 'GET',
                credentials: 'include',
            }),
        }),
        getUserReward: builder.query({
            query: (id) => ({
                url: `${USER_ACTIVE_REWARDS_DATA_URL}/${id}`,
                method: 'GET',
                credentials: 'include',
            }),
            providesTags: ['UserRewards'], // ✅ Enables automatic cache invalidation
        }),
        getUserRedeemedHistory: builder.mutation({
            query: ({ id, selectedMonth, selectedYear }) => ({
                url: `${USER_REWARD_REDEEMED_HISTORY_URL}/${id}?selectedMonth=${selectedMonth}&selectedYear=${selectedYear}`,
                method: 'GET',
                credentials: 'include',
            }),
        }),
        // getRewardQrCode: builder.mutation({
        //     query: ({ rewardId, userId, pointsRequired }) => ({
        //         url: `${USER_REWARD_QRCODE_URL}/${rewardId}/${userId}/${pointsRequired}`,
        //         method: 'GET',
        //         credentials: 'include',
        //     }),
        // }),   
        getRewardQrCodeBatch: builder.mutation({
            query: (rewards) => ({
              url: `${USER_REWARD_QRCODE_URL}`,
              method: 'POST',
              body: { rewards }, // Send an array of rewards
              credentials: 'include',
            }),
        }),
        getDecryptRewardQrCode: builder.mutation({
            query: (encryptedData) => ({
                url: `${USER_DECRYPT_REWARD_QRCODE_URL}`,
                method: 'POST',
                body: { encryptedRewardData: encryptedData },
                headers: {
                    'Content-Type': 'application/json',
                },
                credentials: 'include',
              }),
        }),
        userChangedPassword: builder.mutation({
            
            query: (data) => ({
                url: USER_CHANGE_PASSWORD_URL,
                method: 'PUT',
                body: data,
                credentials: 'include',
            }),
        }),
        userSendEmailOtp: builder.mutation({
            query: (email) => ({
                url: USER_SEND_EMAIL_OTP_URL,
                method: 'POST',
                body: email,
                credentials: 'include',
            }),
        }),
        // userVerifyEmail: builder.mutation({
        //     query: ({email, otp, expirationTime, recaptchaToken}) => ({
        //         url: USER_VERIFY_EMAIL_URL,
        //         method: 'POST',
        //         body: { email, otp, expirationTime, recaptchaToken},
        //         credentials: 'include',
        //     }),

        // }),
    
        userVerifyEmail: builder.mutation({
            query: (data) => ({
                url: USER_VERIFY_EMAIL_URL,
                method: 'POST',
                body: data,
                credentials: 'include',
            }),
        }),
        checkAndExpiredPointsTransactions: builder.mutation({
            query: (id) => ({
                url: `${USER_UPDATE_EXPIRED_TRANSACTION_URL}/${id}`, 
                method: 'POST',
                credentials: 'include',
            }),
        }),
        checkAndExpiredStampsTransactions: builder.mutation({
            query: (id) => ({
                url: `${USER_UPDATE_STAMP_EXPIRED_TRANSACTION_URL}/${id}`, 
                method: 'POST',
                credentials: 'include',
            }),
        }),
        userForgetPasswordVerifyEmail: builder.mutation({
            query: (data) => ({ 
              url: USER_FORGET_PASSWORD_VERIFY_OTP_URL,
              method: 'POST',
              body: { 
                email: data.email, 
                otp: data.otp, 
                expirationTime: data.expirationTime,
                recaptchaToken: data.recaptchaToken,
              },
              credentials: 'include',
            }),
        }),
        userForgotPasswordSendEmailOtp: builder.mutation({
            query: (email) => ({
                url: USER_FORGET_PASSWORD_SEND_EMAIL_OTP_URL, 
                method: 'POST',
                body: email,
                credentials: 'include',
            }),
        }),
        userResetPassword: builder.mutation({
            query: ({email, password}) => ({
                url: USER_RESET_PASSWORD_URL, 
                method: 'POST',
                body: { email, password},
                credentials: 'include',
            }),
        }),
        getStampRewardData: builder.mutation({
            query: (userId) => ({
                url: `${USER_STAMP_REWARD_DATA_URL}/${userId}`,
                method: 'GET',
                credentials: 'include',
            }),
        }),
        checkIfEmailExists: builder.mutation({
            query: (email) => ({
              url: USER_CHECK_EMAIL_EXIST_URL,
              method: 'POST',
              body: email,
              credentials: 'include',
            }),
        }),
        getPointsExpiringSoonTransactions: builder.mutation({
            query: (userId) => ({
              url: `${USER_POINTS_EXPIRY_SOON_URL}/${userId}`,
              method: 'GET',
              credentials: 'include',
            }),
        }),
        getNotifications: builder.query({
            query: (userId) => `/notifications/${userId}`,
            providesTags: ['Notification'],
        }),
        markAsRead: builder.mutation({
        query: (id) => ({
            url: `/notifications/${id}/read`,
            method: 'PATCH',
        }),
        invalidatesTags: ['Notification'],
        }),
    })
})

export const { 
    // useGoogleLoginMutation,
    useLoginMutation, 
    useLogoutMutation, 
    useRegisterMutation, 
    useUpdateUserMutation, 
    useDeleteUserMutation,
    useGetActiveRewardsDataMutation,
    useGetUserDataMutation,
    useFetchUserPointTransactionsMutation,
    useFetchUserStampTransactionsMutation,
    useGetUserRewardQuery,
    useGetUserRedeemedHistoryMutation,
    // useGetRewardQrCodeMutation,
    useGetRewardQrCodeBatchMutation,
    useGetDecryptRewardQrCodeMutation,
    useUserChangedPasswordMutation,
    useUserSendEmailOtpMutation,
    useUserVerifyEmailMutation,
    // useUserPhoneExistsQuery,
    useCheckAndExpiredPointsTransactionsMutation,
    useCheckAndExpiredStampsTransactionsMutation,
    useUserForgetPasswordVerifyEmailMutation,
    useUserForgotPasswordSendEmailOtpMutation,
    useUserResetPasswordMutation,
    useGetStampRewardDataMutation,
    useCheckIfEmailExistsMutation,
    useGetPointsExpiringSoonTransactionsMutation,
    useGetNotificationsQuery,
    useMarkAsReadMutation,
} = usersApiSlice;